import { graphql } from 'gatsby';

/**
 * @param {Object} props
 * @param {string} locale
 */
export const diagramMapping = (props, locale) => {
  return {
    key: props?.key,
    title: props?.[`title_${locale}`] ?? '',
    items:
      props?.diagramcardsgroups?.map?.((group) =>
        group.diagramcards?.map((card) => ({
          backgroundImage: card?.backgroundImage?.childImageSharp?.fluid,
          description: card?.[`description_${locale}`] ?? '',
          disclaimer: card?.[`disclaimer_${locale}`] ?? '',
        })),
      ) ?? [],
  };
};

/**
 * GraphQL Query
 */
export const query = graphql`
  fragment Diagram on StrapiWidgetrels {
    diagram {
      key: id
      title_en
      title_es
      diagramcardsgroups {
        diagramcards {
          backgroundImage {
            childImageSharp {
              fluid(maxWidth: 800, quality: 80) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
          description_en
          description_es
          disclaimer_en
          disclaimer_es
        }
      }
      widgetPosition
    }
  }
`;
